import { render, staticRenderFns } from "./ModalOcpbCareHistory.vue?vue&type=template&id=48a4f7fb&"
import script from "./ModalOcpbCareHistory.vue?vue&type=script&lang=js&"
export * from "./ModalOcpbCareHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports